export type PortalTheme = "light" | "dark" | "system";
export type PortalLocale = "cs" | "en";

export const portalThemeStorageKey = "takeres-client-portal-theme";
export const portalLocaleCookieName = "takeres-client-portal-locale";

export function isPortalLocale(value: unknown): value is PortalLocale {
  return value === "cs" || value === "en";
}

export function resolvePortalLocale(value: unknown): PortalLocale {
  return isPortalLocale(value) ? value : "cs";
}

export function readPortalLocaleCookie(cookieHeader: string): PortalLocale {
  const prefix = `${portalLocaleCookieName}=`;
  const value = cookieHeader.split(";").map((part) => part.trim()).find((part) => part.startsWith(prefix))?.slice(prefix.length);
  return resolvePortalLocale(value);
}

export function portalLocaleCookie(locale: PortalLocale, secure: boolean): string {
  return `${portalLocaleCookieName}=${locale}; Path=/; Max-Age=31536000; SameSite=Lax${secure ? "; Secure" : ""}`;
}

export function isPortalTheme(value: unknown): value is PortalTheme {
  return value === "light" || value === "dark" || value === "system";
}

// Run in the document head before paint; the provider keeps this in sync afterward.
export const portalThemeBootstrap = `(()=>{try{const t=localStorage.getItem(${JSON.stringify(portalThemeStorageKey)});document.documentElement.dataset.theme=t==="dark"||(t==="system"&&matchMedia("(prefers-color-scheme: dark)").matches)?"dark":"light"}catch{document.documentElement.dataset.theme="light"}})()`;
